import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2 15.6c.19.25.49.4.8.4h.04a.99.99 0 0 0 .81-.47l5-8a1.003 1.003 0 0 0-1.7-1.06l-4.23 6.76L8.8 10.4c-.33-.44-.96-.53-1.4-.2-.44.33-.53.96-.2 1.4l3 4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.51 21.86c.15.09.32.13.49.13V22c.17 0 .33-.04.48-.12l.078-.044c.487-.27 3.024-1.682 4.322-2.806 2.01-1.74 4.14-4.76 4.12-8.04v-7c0-.42-.26-.79-.65-.93-1.85-.68-5.19-1.11-8.51-1.06-3.57.05-6.55.44-8.2 1.07-.39.15-.64.52-.64.94.007.681.004 1.445.002 2.235L3 7.47V11c.02 2.75 1.69 5.92 4.31 8.12 1.37 1.16 4.09 2.68 4.2 2.74ZM5.01 4.72c1.53-.41 4.05-.69 6.85-.72 2.63-.04 5.42.26 7.14.73V11c.01 2.15-1.33 4.7-3.47 6.55-.9.77-2.67 1.81-3.52 2.29-.82-.48-2.51-1.49-3.45-2.28-2.11-1.78-3.54-4.42-3.55-6.57V4.72Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShieldWithCheckMark;
